<ng-container *transloco="let t;">
    <!-- Validation Modal -->
<div>
    <form [formGroup]="validationForm" (ngSubmit)="applyValidation()">
        <div class="modal-header">
            <h4 class="modal-title" id="myModalLabel1">{{ t('Modal title manage validation - (Validation field modal) - Manage Validation') }}</h4>
            <button type="button" class="close" aria-label="Close" (click)="activeModal.close('')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body" tabindex="0" ngbAutofocus>
            <div class="form-group">
                <label>{{ t('Edit validation field title - (Validation field modal) - Edit Validation') }}</label>
                <ng-select [items]="editValidation" bindLabel="label" bindValue="value" [readonly]="readonly" formControlName="validation_type" [searchable]="searchable" [placeholder]="t('Edit validation field placeholder - (Validation field modal) - Edit Validation field placeholder')"></ng-select>
            </div>
            
            <!-- Numbers -->
            <div class="number-validation-section" *ngIf="vForm.validation_type.value === 'numbers'">
                <div class="form-group">
                    <label class="form-label">{{ t('Select type field title (Validation field modal) - Select Type') }}</label>
                    <ng-select [items]="numberValidationtype" bindLabel="label" bindValue="value" [readonly]="readonly" [placeholder]="t('Select type field placeholder - (Validation field modal) - Select Type field placeholder')" formControlName="number_validation_type" [searchable]="searchable" [ngClass]="{ 'is-invalid error': validationFormSubmitted && vForm.number_validation_type.errors }">
                    </ng-select>
                    <div *ngIf="validationFormSubmitted && vForm.number_validation_type.errors" class="invalid-feedback" [ngClass]="{ 'd-block': validationFormSubmitted && vForm.number_validation_type.errors }">
                        <div *ngIf="vForm.number_validation_type.errors.required">{{ t('Select number type field error message - (Validation field modal) - Select Number Type') }}</div>
                    </div>
                </div>

                <div class="form-group number-validation-box" *ngIf="vForm.number_validation_type.value">
                    <div>
                        <label class="form-label">{{ t('Min field title (Validation field modal) - Min') }}</label>
                        <input type="number" class="form-control" formControlName="min" aria-describedby="" />
                    </div>
                    <div>
                        <label class="form-label">{{ t('Max field title - (Validation field modal) - Max') }}</label>
                        <input type="number" class="form-control" formControlName="max"  aria-describedby="" />
                    </div>
                    <div *ngIf="vForm.number_validation_type.value !== 'numbers_characters'">
                        <label class="form-label">{{ t('Decimal field title - (Validation field modal) - Decimals') }}</label>
                        <input type="number" class="form-control" formControlName="decimals" aria-describedby="" />
                    </div>
                </div>
            </div>
            <!-- / Numbers -->

            <!-- Letters or Numbers & Letters -->
            <div class="form-group" *ngIf="vForm.validation_type.value === 'letters' || vForm.validation_type.value === 'numbers_letters'">
                <label class="form-label">{{ t('Total character field title - (Validation field modal) - Total Character') }}</label>
                <input type="number" class="form-control" formControlName="max"  aria-describedby="" />
            </div>
            <!-- / Letters or Numbers & Letters -->

            <!-- Custom Validation -->
           <div class="custom-validation-section" *ngIf="vForm.validation_type.value === 'custom_regex_validation'">
                <div class="form-group">
                    <label class="form-label">{{ t('Regular expression field title - (Validation field modal) - Regular Expression') }}</label>
                    <input type="text" class="form-control" formControlName="regular_expression" aria-describedby="" />
                </div>

                <div class="form-group">
                    <label class="form-label">{{ t('Validation help text field title - (Validation field modal) - Validation help text') }}</label>
                    <input type="text" class="form-control" formControlName="validation_help_text" aria-describedby="" />
                </div>
           </div>
            <!-- / Custom Validation -->
        </div>
        <div class="modal-footer">
            <button type="reset" class="btn btn-outline-secondary" (click)="activeModal.close('')" rippleEffect>{{ t('Cancel button title (cancel button) - Cancel') }}</button>
            <button type="submit" class="btn btn-primary" rippleEffect>{{ t('Save button text (save button) - save') }}</button>
        </div>
    </form>
</div>
<!-- / Validation Modal -->
</ng-container>